import { Alert } from "@mui/material";
import React from "react";

import "./KSOPDisclaimer.css";
import { SixDegreesWealthImg } from "../../../assets";

const KSOPDisclaimer = () => {
	return (
		<div className="ksop-disclaimer">
			<h3 className="disclaimer-heading">Alexis Hudson Pigg, CRPS®, CPFA™</h3>
			<div className="disclaimer-sub-heading">Wealth Advisor</div>
			<div className="disclaimer-container">
				<div className="left-container">
					<div className="name">The Alteri Group</div>
					<div className="address-heading">Primary</div>
					<div className="address">303 S. Temple Drive. Suite 300 Diboll, TX 75941</div>
					<div className="address-heading">Lufkin (By Appointment)</div>
					<div className="address">415 S. First Street, Suite, 100 Lufkin, TX 75901</div>
					<div className="phone">
						<strong>Direct: </strong>(936) 299-4303
					</div>
					<div className="website-one">
						<a href="https://alexis.hudsonpigg@6degreeswealth.com" target="_blank" rel="noreferrer">
							alexis.hudsonpigg@6degreeswealth.com
						</a>
					</div>
					<div className="website-two">
						<a href="https://thealterigroup.6degreeswealth.com" target="_blank" rel="noreferrer">
							thealterigroup.6degreeswealth.com
						</a>
					</div>
				</div>
				<div className="right-container">
					<img src={SixDegreesWealthImg} alt="SixDegreesWealthImg" />
				</div>
			</div>
		</div>
	);
};

export default KSOPDisclaimer;
